export function mapToRange(uuid: string, maxOutput: number = 4) {
    let hash = 0;
    for (let i = 0; i < uuid.length; i++) {
        hash = (hash << 5) - hash + uuid.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return (Math.abs(hash) % maxOutput) + 1;
}